import { START_DOWNLOAD, UPDATE_DOWNLOAD, DOWNLOAD_PROGRESS, DOWNLOAD_COMPLETE, UNDO_DOWNLOAD } from '@/redux/actions/socket.actions'
import { LOGOUT } from '@/redux/actions/auth.actions'

const initalState = {
	download: {
		progress: {},
		response: '',
		downloading: false,
		showInfo: false,
		// Timestamp of the last finished download batch (see DOWNLOAD_COMPLETE).
		completedAt: null
	}
}

const download = (state = initalState.download, action) => {
	switch (action.type) {
		case START_DOWNLOAD:
			return { ...state, ...action.payload }

		case UPDATE_DOWNLOAD:
			return {
				...state,
				response: action.payload?.response,
				downloading: action.payload?.downloading,
				showInfo: action.payload?.showInfo || state.showInfo
			}

		case DOWNLOAD_PROGRESS:
			const newProgresses = {...action.payload}
			// Ignore updates that don't increase or fail the progress
			for(const key in newProgresses){
				if(state.progress[key]?.currentProgress > newProgresses[key]?.currentProgress && newProgresses[key].currentProgress !== 3){
					delete newProgresses[key]
				}
			}
			return {
				...state,
				progress: {
					...state.progress,
					...newProgresses
				}
			}
		case DOWNLOAD_COMPLETE:
			const progress = JSON.parse(JSON.stringify(state.progress))
			for (const fileProgress of Object.values(progress)) {
				if(fileProgress.currentProgress !== 3)
					fileProgress.currentProgress = fileProgress.totalProgress
			}

			return { ...state, progress, completedAt: action.payload?.completedAt ?? null }
		case UNDO_DOWNLOAD:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return {
				progress: {},
				response: '',
				downloading: false,
				showInfo: false,
				completedAt: null
			}

		default:
			return state
	}
}

export default {
	name: 'socket',
	reducers: {
		download
	}
}
